var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoShortWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26.981 20.211",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 54915"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 0.412,
    "data-name": "Group 15284",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m4.863 7.601.572-.693a2.008 2.008 0 0 0 1.314.54c.4 0 .635-.159.635-.432 0-.248-.151-.375-.887-.566-.887-.229-1.459-.477-1.459-1.373a1.382 1.382 0 0 1 1.541-1.341 2.531 2.531 0 0 1 1.635.566l-.5.737A2.051 2.051 0 0 0 6.57 4.6c-.371 0-.566.172-.566.4 0 .292.189.388.95.585.893.235 1.4.559 1.4 1.348 0 .883-.667 1.379-1.616 1.379a2.784 2.784 0 0 1-1.875-.711Z",
    "data-name": "Path 18558"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.118 4.702H8.779v-.9h3.647v.9h-1.339v3.547h-.968Z",
    "data-name": "Path 18559"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.784 6.026a2.338 2.338 0 1 1 2.332 2.3 2.288 2.288 0 0 1-2.332-2.3Zm3.664 0a1.345 1.345 0 0 0-1.332-1.4 1.328 1.328 0 0 0-1.32 1.4 1.345 1.345 0 0 0 1.333 1.4 1.328 1.328 0 0 0 1.319-1.4Z",
    "data-name": "Path 18560"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.32 3.799h2.012a1.743 1.743 0 0 1 1.283.451 1.416 1.416 0 0 1 .377 1.03 1.381 1.381 0 0 1-.943 1.379l1.075 1.589h-1.132l-.956-1.424h-.748v1.424h-.968Zm1.949 2.161c.472 0 .742-.254.742-.642 0-.42-.289-.636-.761-.636h-.962V5.96Z",
    "data-name": "Path 18561"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m23.947 6.494-1.691-2.7h1.132l1.05 1.786 1.069-1.786h1.1L24.916 6.47v1.773h-.968Z",
    "data-name": "Path 18562"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 15285",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 0.412,
    d: "M1.938 3.287H.206V1.952h1.732V.21h1.359v1.742h1.732v1.335H3.297v1.742H1.938Z",
    "data-name": "Path 18565"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 0.412,
    d: "M4.853 9.829h2.386l2.645 4.3 2.645-4.3h2.386v10.176h-2.2v-6.643l-2.832 4.346h-.058l-2.8-4.3v6.6H4.853Z",
    "data-name": "Path 19285"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 0.412,
    d: "M17.332 9.829h3.921a5.094 5.094 0 1 1 0 10.176h-3.925Zm3.921 8.155a3.068 3.068 0 0 0 0-6.135h-1.711v6.135Z",
    "data-name": "Path 19286"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoShortWhite);
export default __webpack_public_path__ + "static/media/logo-short-white.d36645c830cd7829175d8c0a1de09594.svg";
export { ForwardRef as ReactComponent };